import React, { Suspense, lazy } from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone } from '@fortawesome/free-solid-svg-icons';
import { elRed } from 'src/styles/colors';
import Menu from 'src/components/Menu';
import DataState from 'src/components/DataState';
import useWindowWidth from 'src/hooks/useWindowWidth';
import { MOBILE_MENU_MAX_WIDTH } from 'src/styles/breakpoints';
import MobileMenu from '../Menu/MobileMenu';

const MainContainer = styled.div`
  position: relative;
  z-index: 99999;
  width: 100%;
  max-width: 100%;
`;

const DemographicContainer = styled.div`
  display: flex;
  flex-direction: row;
  background-color: #000;
  height: 25px;
  padding-left: 5%;
  padding-right: 5%;
  padding-top: 10px;
  padding-bottom: 5px;
`;

const LeftContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
`;

const CenterContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex: none;
  white-space: nowrap;
`;

const RightContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  justify-content: flex-end;
`;

const DetailContainer = styled.div`
  color: #fff;
  font-size: 15px;
  font-weight: 400;
`;

const HeroContainer = styled.div`

`;

const heroImageStyle = {
  height: '75%'
}

const Header = () => {
  const windowWidth = useWindowWidth();
  const useMobileMenu = windowWidth < MOBILE_MENU_MAX_WIDTH;

  return (
    <MainContainer>
      {!useMobileMenu &&
        <DemographicContainer>
          <>
            <LeftContainer>
              <DetailContainer>
                jbrinkley@equiplincauctions.com
              </DetailContainer>
            </LeftContainer>
            <CenterContainer>
              <DetailContainer>
                Live & Virtual Auctions — Selling Commercial Assets Nationwide
              </DetailContainer>
            </CenterContainer>
            <RightContainer>
              <FontAwesomeIcon
                icon={faPhone}
                size='sm'
                style={{color: elRed, marginTop: '4px'}}
              />
              <DetailContainer>
                (678) 788-0965
              </DetailContainer>
            </RightContainer>
          </>
        </DemographicContainer>
      }
      {useMobileMenu ?
        <MobileMenu /> :
        <Menu />
      }
    </MainContainer>
  )
}

export default Header;
